import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim is grounded in EAKC-MVP:
//   docs/content/07-building-on-1gb-ram.md §17:30 + §19:30
//   src/lib/rag/adaptive-chunker.ts (chunkMarkdownStructured ⇄ chunkGeneralStructured; fix @1108)
//   .claude/CLAUDE.md deployment topology (sync runs in-process on the Dokploy VPS, not Railway)

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.5, caption: "Two weeks of debugging. The fix was one line of code." },
];

export const SYMPTOM: ScriptLine[] = [
  { scene: "symptom", fromSec: 0.3, holdSec: 5.5, caption: "My GitHub sync died at the same spot every time — around 20% — and then went silent." },
  { scene: "symptom", fromSec: 6, holdSec: 5.5, caption: "No crash log. No stack trace. The process just terminated, like it ran out of memory." },
  { scene: "symptom", fromSec: 12, holdSec: 5.5, caption: "It happened right at the Step 2 → Step 3 boundary, on the first big markdown file." },
];

export const DIAGNOSIS: ScriptLine[] = [
  { scene: "diagnosis", fromSec: 0.3, holdSec: 5.5, caption: "Obvious diagnosis: out of memory. The backend's on a 1 GB box — surely that's it." },
  { scene: "diagnosis", fromSec: 6, holdSec: 5.5, caption: "So I upgraded Railway to the Hobby plan: eight gigs of RAM. Triggered the sync." },
  { scene: "diagnosis", fromSec: 12, holdSec: 5.5, caption: "It crashed at 20%. Exactly the same. Eight times the memory changed nothing." },
];

export const TWIST: ScriptLine[] = [
  { scene: "twist", fromSec: 0.3, holdSec: 5.5, caption: "Then it hit me: where does the sync actually run?" },
  { scene: "twist", fromSec: 6, holdSec: 5.5, caption: "Railway only runs the Docling OCR service. The sync runs in-process on the Dokploy VPS." },
  { scene: "twist", fromSec: 12, holdSec: 4.5, caption: "I'd spent a week tuning memory on a server the code never touched." },
];

export const REALBUG: ScriptLine[] = [
  { scene: "realbug", fromSec: 0.3, holdSec: 5.5, caption: "The real bug wasn't memory at all. It was a stack overflow in the adaptive chunker." },
  { scene: "realbug", fromSec: 6, holdSec: 6, caption: "An oversized markdown section asked the general chunker to split it." },
  { scene: "realbug", fromSec: 12, holdSec: 7, caption: "The general chunker saw headings, handed it back to markdown — which handed it back. Forever." },
];

export const CODE: ScriptLine[] = [
  { scene: "code", fromSec: 0.3, holdSec: 6, caption: "Two functions politely passing the same section back and forth until the call stack blew." },
  { scene: "code", fromSec: 6.5, holdSec: 6.5, caption: "Node doesn't throw a catchable error for that — it just dies. So it looked exactly like OOM." },
  { scene: "code", fromSec: 13.5, holdSec: 8, caption: "The fix: call the plain splitter directly. No heading check, no delegation, no loop." },
];

export const PAYOFF: ScriptLine[] = [
  { scene: "payoff", fromSec: 0.3, holdSec: 5.5, caption: "670+ files chunked into 2,110 vectors. Zero errors. Flat memory the whole way." },
  { scene: "payoff", fromSec: 6, holdSec: 5.5, caption: "Two weeks of memory work never touched the bug — because it was never a memory bug." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.3, holdSec: 5, caption: "The hardest bugs disguise themselves as the obvious one. Always ask where the code runs." },
  { scene: "outro", fromSec: 5.5, holdSec: 3.8, caption: "Next: seven layers of security I built solo, enforced at the database." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
